var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      !_vm.copyFlag
        ? _c(
            "el-popconfirm",
            {
              attrs: { title: "信息已隐藏，确定要查看？" },
              on: { confirm: _vm.handleView },
            },
            [
              _c(
                "span",
                {
                  class: _vm.channel == 92 ? (_vm.copyFlag ? "" : "link") : "",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [_vm._v(_vm._s(_vm.row[_vm.rowKey]))]
              ),
            ]
          )
        : _c(
            "span",
            { class: _vm.channel == 92 ? (_vm.copyFlag ? "" : "link") : "" },
            [_vm._v(_vm._s(_vm.row[_vm.rowKey]))]
          ),
      _vm.copy && _vm.copyFlag && _vm.row[_vm.rowKey]
        ? _c("BjCopyIcon", { attrs: { copy: _vm.row[_vm.rowKey] } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }